import _extends from "@babel/runtime/helpers/esm/extends";
import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
import RECLog from "../RECLog.js";
import RECLogContext from "../RECLogContext.js";
export const attributionContextLogType = 'tracking.attribution_context';
export const ATTRIBUTION_QUERY_PARAM = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_term', 'utm_content', 'dzr_source', 'dzr_content'];
export function getAttributionQueryParams(query) {
  const params = ATTRIBUTION_QUERY_PARAM.reduce((acc, param) => {
    const value = query.get(param);
    if (value) {
      acc[param] = typeof value === 'string' ? value : value[0];
    }
    return acc;
  }, {});
  return params;
}
var _marketingParams = /*#__PURE__*/_classPrivateFieldLooseKey("marketingParams");
var _dzrUniqId = /*#__PURE__*/_classPrivateFieldLooseKey("dzrUniqId");
class AttributionContextLog extends RECLog {
  constructor(params) {
    super(_extends({
      type: attributionContextLogType,
      version: '1.0.0'
    }, new RECLogContext({
      name: attributionContextLogType,
      version: '1.0.0',
      userID: params.userID
    })));
    Object.defineProperty(this, _marketingParams, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _dzrUniqId, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _marketingParams)[_marketingParams] = params.marketingParams;
    _classPrivateFieldLooseBase(this, _dzrUniqId)[_dzrUniqId] = params.dzrUniqId;
  }
  serialize() {
    const payload = _extends({}, super.serialize(), _classPrivateFieldLooseBase(this, _marketingParams)[_marketingParams], {
      dzr_uniq_id: _classPrivateFieldLooseBase(this, _dzrUniqId)[_dzrUniqId],
      url: location.href
    });
    if (document.referrer) {
      payload.referrer = document.referrer;
    }
    return payload;
  }
}
export default AttributionContextLog;
//# sourceMappingURL=AttributionContext.js.map